import {useEffect} from 'react';

function InstagramProfile() {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = 'https://www.instagram.com/embed.js';
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="bg-[#faf6ee] px-4 py-16 sm:px-6 lg:px-20 lg:py-24">
      <div className="mx-auto flex max-w-4xl justify-center">
        <div className="w-full max-w-[700px] overflow-hidden rounded-2xl bg-white shadow-lg">
          <blockquote
            className="instagram-media"
            data-instgrm-permalink="https://www.instagram.com/vedanova.life/"
            data-instgrm-version="14"
            style={{
              background: '#FFF',
              border: 0,
              borderRadius: '3px',
              boxShadow: 'none',
              margin: '0 auto',
              maxWidth: '700px',
              minWidth: '326px',
              padding: 0,
              width: '100%',
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default InstagramProfile;